import PayPayrollItemCompany from '@/api/hr/pay-payroll-item-company'
import PayPayrollItemType from '@/api/hr/pay-payroll-item-type'
import PayItemOvertime from '@/api/hr/pay-item-overtime'
import PayItemAllowance from '@/api/hr/pay-item-allowance'
import PayItemCompensate from '@/api/hr/pay-item-compensate'
import PayItemIncentiveBonus from '@/api/hr/pay-item-incentive-bonus'
import PayItemDeduction from '@/api/hr/pay-item-deduction'
import Company from '@/api/administration/company'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  companies: [],
  payPayrollItemTypes: [],
  payPayrollItems: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_COMPANIES(state, companies) {
    state.companies = companies
  },
  RECEIVE_PAYROLL_ITEM_TYPES(state, payPayrollItemTypes) {
    state.payPayrollItemTypes = payPayrollItemTypes
  },
  RECEIVE_PAYROLL_ITEMS(state, payPayrollItems) {
    state.payPayrollItems = payPayrollItems
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayPayrollItemCompany.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayPayrollItemCompany.store(data)
  },

  update(context, { id, ...data }) {
    return PayPayrollItemCompany.update(id, data)
  },

  // destroy(context, id) {
  //   return PayPayrollItemCompany.destroy(id)
  // },

  fetchCompanies(context) {
    return Company.get({
      params: { page: -1 },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECEIVE_COMPANIES', response.data)
    })
  },

  fetchPayrollItemTypes(context) {
    return PayPayrollItemType.get({ params: { page: -1 } }).then(response => {
      context.commit('RECEIVE_PAYROLL_ITEM_TYPES', response.data)
    })
  },

  fetchPayrollItems(context, itemType) {
    context.commit('RECEIVE_PAYROLL_ITEMS', [])

    switch (itemType.toLowerCase()) {
      case 'overtime':
        return PayItemOvertime.get({ params: { page: -1 } }).then(response => {
          context.commit('RECEIVE_PAYROLL_ITEMS', response.data.map(p => ({ value: p.ot_id, text: p.ot_name })))
        })

      case 'allowance':
        return PayItemAllowance.get({ params: { page: -1 } }).then(response => {
          context.commit(
            'RECEIVE_PAYROLL_ITEMS',
            response.data.map(p => ({ value: p.allowance_id, text: p.allowance_item }))
          )
        })

      case 'compensation':
        return PayItemCompensate.get({ params: { page: -1 } }).then(response => {
          context.commit(
            'RECEIVE_PAYROLL_ITEMS',
            response.data.map(p => ({ value: p.compensate_id, text: p.compensate_item }))
          )
        })

      case 'incentive':
        return PayItemIncentiveBonus.get({ params: { page: -1 } }).then(response => {
          context.commit(
            'RECEIVE_PAYROLL_ITEMS',
            response.data.map(p => ({ value: p.inc_bonus_id, text: p.inc_bonus_item }))
          )
        })

      case 'deduction':
        return PayItemDeduction.get({ params: { page: -1 } }).then(response => {
          context.commit(
            'RECEIVE_PAYROLL_ITEMS',
            response.data.map(p => ({ value: p.deduction_id, text: p.deduction_item }))
          )
        })
    }
  }
}
